import { useEffect } from "react";

import { installContentProtection } from "../contentProtection";

/**
 * FEAT-17: while `enabled`, the page's content cannot be right-clicked or
 * selected (see ../contentProtection). Called by the three pages that show
 * question content during a test — never by the gate, the practice prelude or
 * a recruiter preview.
 */
export function useContentProtection(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    return installContentProtection();
  }, [enabled]);
}
